  
  <script setup>
  import { reactive, ref } from 'vue'
  import { useStore } from 'vuex'
  import { useRouter } from 'vue-router'
  import axios from 'axios'
  
  const store = useStore()
  const router = useRouter()
  
  const user = store.getters.getUser
  const form = reactive({
    first_name: user.first_name || '',
    last_name:  user.last_name  || '',
    email:      user.email      || '',
    avatar:     user.avatar     || ''
  })
  
  const pw = reactive({ current: '', new: '', confirm: '' })
  
  const saving   = ref(false)
  const changing = ref(false)
  
  function resetForm() {
    form.first_name = user.first_name
    form.last_name  = user.last_name
    form.email      = user.email
    form.avatar     = user.avatar
  }
  
  async function saveProfile() {
    saving.value = true
    try {
      await store.dispatch('user/updateProfile', { ...form })
      router.go(0)
    } catch {
      alert('Failed to save profile.')
    } finally {
      saving.value = false
    }
  }
  
  async function changePassword() {
    if (pw.new !== pw.confirm) return alert('Passwords do not match.')
    changing.value = true
    try {
      await axios.post('/api/auth/change-password', {
        current_password: pw.current,
        new_password: pw.new
      })
      alert('Password updated.')
      pw.current = pw.new = pw.confirm = ''
    } catch {
      alert('Failed to update password.')
    } finally {
      changing.value = false
    }
  }
  </script>
  
  <style scoped>
  /* replicate your layout’s grid gutter */
  .container {
    max-width: 960px;
    margin: 0 auto;
  }
  </style>
  